import React, { Component } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';
import moment from 'moment';
import './Chart.css';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export default function Chart_ReportCOD({ info, xlabel, solorpower, e100, ens }) {
    const plot = [
        { color: "#5DE622", unit: 'MWh', name: 'Solar Energy', dp: 3 },
        { color: "#566573", unit: 'MWh', name: 'Energy not Supply', dp: 3 },
        { color: "#F1C40F", unit: 'MWh', name: 'E100', dp: 3 },
    ]

    const options = {
        height: 615,
        zoomEnabled: true,
        toolTip: {
            shared: true,
            borderColor: 'rgba(204, 204, 220, 0.12)',
            borderThickness: 1,
            cornerRadius: 2,
            contentFormatter: function (e) {
                if (window.screen.width < 576) {
                    return null
                }
                if (e.entries[0].dataPoint !== undefined) {
                    var elem = '<p style = "font-family: Inter !important;font-size: 12px !important;margin-bottom:0px;color: black !important;">Year : ' + moment(new Date(e.entries[0].dataPoint.x)).add(0, 'days').format('YYYY') + '</p>'
                    elem += '<div class="measure-table" style = "font-family: Inter !important;margin-top:0px;">'
                    for (let i = 0; i < e.entries.length; i++) {
                        if (e.entries[i].dataPoint.y !== undefined) {
                            const sname = e.entries[i].dataSeries.name
                            const filtered = plot.filter(item => item.name === sname);
                            if (filtered.length > 0) {
                                var value = ""
                                if (e.entries[i].dataPoint.y !== 0) {
                                    value = e.entries[i].dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: filtered[0].dp, maximumFractionDigits: filtered[0].dp })
                                } else {
                                    value = e.entries[i].dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                                }
                                elem += '<div class="measure-rows font-bold">' +
                                    '<div class="measure-cell" style = "color:' + filtered[0].color + ';font-size: 11px !important;min-width:150px  !important;">' + e.entries[i].dataSeries.name + '</div>' +
                                    '<div class="measure-cell numberright"  style = "padding-right:8px;font-size: 11px !important;color: black !important;">' + value + '</div>' +
                                    '<div class="measure-cell" style = "width:40px;font-size: 11px !important;color: black !important;">' + filtered[0].unit + '</div>' +
                                    '</div>'
                            }
                        }
                    }
                    elem += '</div>'
                    return elem
                }
            }
        },
        responsive: true,
        backgroundColor: "#fff",
        xValueType: 'dateTime',
        animationEnabled: true,
        title: {
            text: info?.SiteName,
            fontSize: 14,
            fontFamily: 'poppins',
            fontWeight: 'bold'
        },
        legend: {
            fontFamily: 'poppins',
            fontSize: 12,
        },
        axisX: {
            interval: 1,
            intervalType: "year",
            labelFormatter: function (e) {
                return moment(new Date(e.value)).format('YYYY')
            },
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'bold',
            labelFontFamily: "poppins",
            labelFontSize: 12,
            labelAngle: 0,
            margin: 0,
            title: xlabel,
            stripLines: [
                {
                    startValue: 0,
                    endValue: 0,
                    color: "#d8d8d8"
                }
            ],
        },
        axisY: {
            title: "Energy (MWh)",
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'bold',
            minimum: 0,
            labelFontFamily: "sans-serif",
            labelFontSize: 12,
            gridDashType: "dash"
        },
        data: [{
            type: "column",
            showInLegend: true,
            name: "Solar Energy",
            color: "#2ECC71",
            markerType: "none",
            dataPoints: solorpower,
            indexLabelFontSize: 10,
            indexLabelFontWeight: "bold",
            indexLabelFontFamily: 'poppins',
            indexLabelPlacement: "outside",
            indexLabelOrientation: "vertical",
            indexLabelFormatter:
                function (e) {
                    if (e.dataPoint.y !== undefined) {
                        if (e.dataPoint.y > 0) {
                            return e.dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
                        }
                        return e.dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                    }
                }
        }, {
            type: "column",
            showInLegend: true,
            name: "Energy not Supply",
            color: "#566573",
            markerType: "none",
            dataPoints: ens,
            indexLabelFontSize: 10,
            indexLabelFontWeight: "bold",
            indexLabelFontFamily: 'poppins',
            indexLabelPlacement: "outside",
            indexLabelOrientation: "vertical",
            indexLabelFormatter:
                function (e) {
                    if (e.dataPoint.y !== undefined) {
                        if (e.dataPoint.y > 0) {
                            return e.dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
                        }
                        return e.dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                    }
                }
        }, {
            type: "line",
            showInLegend: true,
            name: "E100",
            color: "#E74C3C",
            markerType: "none",
            dataPoints: e100
        }]
    }

    return (
        <div className="dashboard-chart-wrapper">
            <CanvasJSChart options={options}
            />
        </div>
    );
}
